module.exports = __webpack_public_path__ + "img/muxuan.4df9de50.png";